import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function CustomToolbar(props) {
    const { label, view, onNavigate, onView, messages } = props;
    const { t } = useTranslation();

    return (
        <Box className="hc-toolbar">
            <Box className="hc-toolbar-row" sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {/* Left area: Today, Prev, Label, Next */}
                <Box
                    className="hc-toolbar-left"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5, // controls spacing between buttons
                    }}
                >
                    <Button
                        //className="hc-btn"
                        onClick={() => onNavigate("TODAY")}
                        sx={{
                            backgroundColor: "#fff",
                            border: "2px solid #E0E0E0",
                            borderRadius: "8px",
                            cursor: "pointer",
                            fontWeight: 700,
                            fontSize: "13px",
                            color: "#666", // orange text (as requested before)
                            fontFamily: "'Nunito', sans-serif",
                            textTransform: "none", // prevents uppercase in MUI buttons
                            transition: "all 0.3s",
                            px: 2,
                            py: 0.8,

                            "&:hover": {
                                backgroundColor: "#E8F0FE",  // light blue fill
                                borderColor: "#1A73E8",      // blue border
                                color: "#1A73E8",            // blue text
                            }
                        }}
                    >
                        {messages?.today ?? t("parent.title.calendar-today")}
                    </Button>

                    <Button
                        //className="hc-btn"
                        onClick={() => onNavigate("PREV")}
                        sx={{
                            backgroundColor: "#fff",
                            border: "2px solid #E0E0E0",
                            borderRadius: "8px",
                            cursor: "pointer",
                            fontWeight: 700,
                            fontSize: "13px",
                            color: "#666", // orange text (as requested before)
                            fontFamily: "'Nunito', sans-serif",
                            textTransform: "none", // prevents uppercase in MUI buttons
                            transition: "all 0.3s",
                            px: 2,
                            py: 0.8,

                            "&:hover": {
                                backgroundColor: "#E8F0FE",  // light blue fill
                                borderColor: "#1A73E8",      // blue border
                                color: "#1A73E8",            // blue text
                            }
                        }}
                    >
                        ← {messages?.previous ?? t("parent.title.calendar-previous")}
                    </Button>

                    <Typography
                        className="hc-toolbar-title"
                        sx={{
                            fontWeight: 700,
                            fontSize: 28,
                            mx: 2, // small spacing before/after label
                            whiteSpace: "nowrap",
                        }}
                    >
                        {label}
                    </Typography>

                    <Button
                        //className="hc-btn"
                        onClick={() => onNavigate("NEXT")}
                        sx={{
                            backgroundColor: "#fff",
                            border: "2px solid #E0E0E0",
                            borderRadius: "8px",
                            cursor: "pointer",
                            fontWeight: 700,
                            fontSize: "13px",
                            color: "#666", // orange text (as requested before)
                            fontFamily: "'Nunito', sans-serif",
                            textTransform: "none", // prevents uppercase in MUI buttons
                            transition: "all 0.3s",
                            px: 2,
                            py: 0.8,

                            "&:hover": {
                                backgroundColor: "#E8F0FE",  // light blue fill
                                borderColor: "#1A73E8",      // blue border
                                color: "#1A73E8",            // blue text
                            }
                        }}
                    >
                        {messages?.next ?? t("parent.title.calendar-next")} →
                    </Button>
                </Box>


                {/* Right buttons */}
                <Box className="hc-toolbar-right" sx={{ display: "flex", gap: 1 }}>
                    <Button
                        //className={`hc-btn ${view === "month" ? "hc-btn-active" : ""}`}
                        sx={{
                            fontFamily: "'Nunito', sans-serif",
                            textTransform: "none",
                            fontWeight: 700,
                            fontSize: "13px",
                            borderRadius: "8px",
                            border: "2px solid",
                            borderColor: view === "month" ? "#1D6ADE" : "#E0E0E0",
                            color: view === "month" ? "#1D6ADE" : "#666",
                            backgroundColor: "#fff",
                            px: 2,
                            py: 0.8,
                            transition: "all 0.3s",

                            "&:hover": {
                                backgroundColor: "#FFF",
                                borderColor: "#1D6ADE",
                                color: "#1D6ADE",
                            }
                        }}
                        onClick={() => onView("month")}
                    >
                        {t("parent.title.calendar-month")}
                    </Button>

                    <Button
                        //className={`hc-btn ${view === "week" ? "hc-btn-active" : ""}`}
                        sx={{
                            fontFamily: "'Nunito', sans-serif",
                            textTransform: "none",
                            fontWeight: 700,
                            fontSize: "13px",
                            borderRadius: "8px",
                            border: "2px solid",
                            borderColor: view === "week" ? "#1D6ADE" : "#E0E0E0",
                            color: view === "week" ? "#1D6ADE" : "#666",
                            backgroundColor: "#fff",
                            px: 2,
                            py: 0.8,
                            transition: "all 0.3s",

                            "&:hover": {
                                backgroundColor: "#FFF",
                                borderColor: "#1D6ADE",
                                color: "#1D6ADE",
                            }
                        }}
                        onClick={() => onView("week")}
                    >
                        {t("parent.title.calendar-week")}
                    </Button>

                    <Button
                        //className={`hc-btn ${view === "day" ? "hc-btn-active" : ""}`}
                        onClick={() => onView("day")}
                        sx={{
                            fontFamily: "'Nunito', sans-serif",
                            textTransform: "none",
                            fontWeight: 700,
                            fontSize: "13px",
                            borderRadius: "8px",
                            border: "2px solid",
                            borderColor: view === "day" ? "#1D6ADE" : "#E0E0E0",
                            color: view === "day" ? "#1D6ADE" : "#666",
                            backgroundColor: "#fff",
                            px: 2,
                            py: 0.8,
                            transition: "all 0.3s",

                            "&:hover": {
                                backgroundColor: "#FFF",
                                borderColor: "#1D6ADE",
                                color: "#1D6ADE",
                            }
                        }}
                    >
                        {t("parent.title.calendar-day")}
                    </Button>

                    <Button
                        //className={`hc-btn ${view === "agenda" ? "hc-btn-active" : ""}`}
                        onClick={() => onView("agenda")}
                        sx={{
                            fontFamily: "'Nunito', sans-serif",
                            textTransform: "none",
                            fontWeight: 700,
                            fontSize: "13px",
                            borderRadius: "8px",
                            border: "2px solid",
                            borderColor: view === "agenda" ? "#1D6ADE" : "#E0E0E0",
                            color: view === "agenda" ? "#1D6ADE" : "#666",
                            backgroundColor: "#fff",
                            px: 2,
                            py: 0.8,
                            transition: "all 0.3s",

                            "&:hover": {
                                backgroundColor: "#FFF",
                                borderColor: "#1D6ADE",
                                color: "#1D6ADE",
                            }
                        }}

                    >
                        {t("parent.title.calendar-agenda")}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}
